import { useGetBackUrlFromLocation } from "@sembark-travel/ui-router"
import { useNavigate } from "react-router"
import { generatePath, useParams } from "../../../router-utils"
import { EditVisaService } from "../../../Visa"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function EditVisaServicePage() {
	const backFromUrl = useGetBackUrlFromLocation()
	const navigate = useNavigate()
	const { visaServiceId } = useParams("/visa/:visaServiceId")
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.CREATE_VISA_SERVICES}
		>
			<EditVisaService
				visaId={visaServiceId}
				onSuccess={() => {
					navigate(generatePath(`/visa/:visaServiceId`, { visaServiceId }))
				}}
				onCancel={() =>
					backFromUrl ? navigate(backFromUrl) : navigate(generatePath("/visa"))
				}
			/>
		</ForbidUnlessAuthorized>
	)
}
